import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRating from "./StarRating";

const RateReview = ({ dealerId, userId }) => {
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [averageRating, setAvgRating] = useState(0);
  const [ratingsData, setRatingsData] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchRatings();
  }, []);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  const baseUrl =
    window.CARLOCA_UPLOADS + "/users/";
  const fetchRatings = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/dealer/reviews",
        { dealer_id: dealerId }
      );
      const resp = response?.data;

      if (resp?.status) {
        const ratingSummary = resp?.data?.ratings_summary || [];
        const defaultRatings = [5, 4, 3, 2, 1].map((star) => {
          const foundRating = ratingSummary.find((r) => r.rating === star);
          return {
            rating: star,
            count: foundRating ? foundRating.count : 0,
            percentage: foundRating ? foundRating.percentage : 0,
          };
        });
        setRatingsData(defaultRatings);
        setReviews(resp?.data?.reviews || []);
        setAvgRating(resp?.data?.average_rating || 0);
      }
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };

  const handleSubmit = async () => {
    if (!storedUserPreferences?.id) {
      toast.warning("Please login to rate this dealer.", optionToast);
      return;
    }
    if (storedUserPreferences?.id === dealerId) {
      toast.warning("You cannot rate yourself as a dealer.", optionToast);
      return;
    }
    if (rating === 0 || review.trim() === "") {
      toast.error("Please provide a rating and review.", optionToast);
      return;
    }

    try {
      const response = await axios.post(
        window.CARLOCA_API + "/dealer/rating",
        {
          user_id: userId,
          dealer_id: dealerId,
          rating,
          review,
        }
      );
      // console.log(response?.data);
      if (response?.data?.status) {
        fetchRatings();
        setRating(0);
        setReview("");
        toast.success(response?.data?.message, optionToast);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const ratingColors = {
    5: "bg-primary",
    4: "bg-primary",
    3: "bg-primary",
    2: "bg-primary",
    1: "bg-primary",
  };

  return (
    <div className="card border-0 mt-5 pt-4" style={{ boxShadow: "unset" }}>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <h4 className="fw-bold fs-5">Ratings Overview</h4>
            <h6 className="text-primary fs-6 mt-3 fw-bold">
              Average Ratings
              <div className="d-inline-flex align-items-baseline mx-2">
                <StarRating rating={averageRating} />
                <span
                  style={{ fontSize: "14px" }}
                  className="text-primary mx-2"
                >
                  ({averageRating})
                </span>
              </div>
            </h6>
            <div className="row">
              <div className="col-11 col-md-7">
                {ratingsData.length > 0 &&
                  ratingsData.some((rate) => rate.count > 0)
                  ? ratingsData.map((rate) => (
                    <div
                      key={rate.rating}
                      className="d-flex align-items-center my-2"
                    >
                      <span
                        className="fw-bold text-primary"
                        style={{ whiteSpace: "nowrap", fontSize: "14px" }}
                      >
                        {rate.rating} ★
                      </span>
                      <div
                        className="progress w-100 mx-2"
                        style={{ height: "8px" }}
                      >
                        <div
                          className={`progress-bar ${ratingColors[rate.rating]
                            }`}
                          role="progressbar"
                          style={{ width: `${rate.percentage}%` }}
                        ></div>
                      </div>
                      <span
                        className="text-primary"
                        style={{ fontSize: "14px" }}
                      >
                        {rate.percentage}%
                      </span>
                    </div>
                  ))
                  : [5, 4, 3, 2, 1].map((star) => (
                    <div
                      key={star}
                      className="d-flex align-items-center my-2"
                    >
                      <span
                        className="fw-bold"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {star} ★
                      </span>
                      <div
                        className="progress w-100 mx-2"
                        style={{ height: "10px" }}
                      >
                        <div
                          className="progress-bar bg-light"
                          style={{ width: "0%" }}
                        ></div>
                      </div>
                      <span>(0)</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <h4 className="fw-bold fs-5">Leave a Review</h4>
            <div className="d-flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`fs-2 mx-1  cursor-pointer ${star <= rating ? "text-warning" : "text-secondary"
                    }`}
                  onClick={() => setRating(star)}
                  style={{ cursor: "pointer" }}
                >
                  ★
                </span>
              ))}
            </div>
            <textarea
              className="form-control mt-2 review-area"
              placeholder="Write your review..."
              value={review}
              rows={5}
              onChange={(e) => setReview(e.target.value)}
            ></textarea>

            <button
              className="btn btn-primary border-0 mt-2"
              onClick={handleSubmit}
            >
              Submit Review
            </button>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-md-6 mt-4">
            <h4 className="fw-bold fs-5">User Reviews</h4>
            {reviews.length > 0 ? (
              reviews.map((rev) => (
                <div
                  key={rev.rate_id + "RVL"}
                  className="d-flex w-100 bg-white rounded-2 p-2 align-items-start my-3"
                  style={{ border: "1px solid #0aa5bd" }}
                >
                  <img
                    src={
                      rev?.user_profile
                        ? baseUrl + rev?.user_profile
                        : "https://placehold.co/80x80?text=No"
                    }
                    alt="User Profile"
                    className="rounded-circle me-2"
                    width="40"
                    height="40"
                    style={{ border: "2px solid #0aa5bd" }}
                  />
                  <div className="w-100">
                    <div className="d-flex justify-content-between w-100 align-items-center flex-wrap">
                      <h6 className="mb-1 fw-bold">{rev?.user_name}</h6>
                      <StarRating rating={rev?.rate} />
                    </div>
                    <p className="mb-0 " style={{ fontSize: "13px" }}>
                      {rev.review.length > 100
                        ? rev.review.substring(0, 100) + "..."
                        : rev.review}
                    </p>
                    {rev.review.length > 100 && (
                      <span
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        Read more
                      </span>
                    )}
                    <small
                      className="text-muted text-end w-100 d-block"
                      style={{ fontSize: "13px" }}
                    >
                      {rev?.human_readable_datetime}
                    </small>
                  </div>
                </div>
              ))
            ) : (
              <p>No reviews yet.</p>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default RateReview;
